import { dayMilliseconds } from "web/constants/date";

export default Date.now() + 5 * dayMilliseconds;
